<template>
  <div>
    <base-header class="mt-4 pb-6" type=""></base-header>
    <b-container fluid class="mt--6">
      <b-row>
        <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
      </b-row>
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col lg="8">
                        <h3>{{language_terms['JOURNAL_VOUCHERS']}}</h3>
                    </b-col>
                    <b-col lg="4">
                       <base-button type="success" @click="onClickNew" class="float-right">
                          <i class="fa fa-plus"></i>
                        </base-button>
                    </b-col>
                  </b-row>
                </div>
              <b-row>
                <b-col md="7">
                  <base-input :label="language_terms['KEYWORD']" :placeholder="language_terms['KEYWORD_INFO']" v-on:keyup.enter="onClickSearch()" v-model="filter.keyword"/>
                </b-col>
                <b-col md="2">
                  <base-input :label="language_terms['SYSTEM_GENERATE']">
                    <el-select v-model="filter.is_generated">
                      <el-option v-for="item in systemOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
                <b-col md="2">
                  <base-input :label="language_terms['VOUCHER_STATUS']">
                    <el-select v-model="filter.is_void">
                      <el-option v-for="item in voucherStatusOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
                  <b-col cols="1" class='mt-4'>
                    <base-button type="primary" @click.native="onClickSearch" class='mt-2'><i class="fa fa-search"></i></base-button>
                  </b-col>
              </b-row>  
            </card>
            <!-- Search Results -->
            <!--<PaginatedTables :myColumns="tableColumns" :tableData="items" :cardTitle="language_terms['SEARCH_RESULTS']" v-if="items.length > 0"/>-->
              <!-- v-if="documents.length > 0"-->
              <b-row v-if="items.length > 0">
                <b-col lg="12">
                  <div class="card-wrapper">
                    <card>
                      <div slot="header" class="mb-0">
                        <b-row>
                          <b-col lg="11">
                              <h3>Search Results</h3>
                          </b-col>
                        </b-row>
                      </div>
                      <b-row class="mt--4">
                        <b-col cols="12" class="mt-3">
                            <b-table-simple hover responsive>
                                <b-thead head-variant="light">
                                  <b-th>{{language_terms['DATE']}} </b-th>
                                  <b-th>{{language_terms['CODE']}}</b-th>
                                  <b-th>{{language_terms['AMOUNT']}} </b-th>
                                  <b-th>{{language_terms['DOCUMENT']}} </b-th>
                                  <b-th>{{language_terms['REFERENCE']}} </b-th>
                                  <b-th>{{language_terms['REMARKS']}}</b-th>
                                </b-thead>
                                <b-tbody>
                                    <tr v-for="(invoice, i) in items" :key="i" @click="onClickVoucher(invoice)">
                                      <td>{{invoice.date}}</td>
                                      <td>{{invoice.code}}</td>
                                      <td>{{(invoice.total_amount * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
                                      <td>{{invoice.doc_reference}}</td>
                                      <td>{{invoice.reference}}</td>
                                      <td>{{invoice.remarks}}</td>
                                    </tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-col>
                      </b-row>                            
                    </card>
                  </div>
                </b-col>
              </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
<script>
import Loading from 'vue-loading-overlay';
import { Select, Option } from 'element-ui'
import axios from "axios";
import { apiRoutes } from "../../../apiRoutes";
import { authHeader } from "../../../global";
import { mapState } from 'vuex';

export default {
  computed:{
    ...mapState({
         language_terms: state => state.languages.language_terms,
    })

  },
  components: {
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      loadingCounter:0,
      filter:{
        keyword:"",
        is_void:'0',
        is_generated:'0'
      },
      items:[],
      voucherStatusOptions: [
        {
          value: "0",
          label: "Active",
        },
        {
          value: "1",
          label: "Voided",
        },
      ],
      systemOptions: [
        {
          value: "1",
          label: "Yes",
        },
        {
          value: "0",
          label: "No",
        },
      ],
    };
  },
  mounted(){
     
  },
  methods:{
    async onClickVoucher(invoice)
    {
      if(invoice)
      {
        this.loadingCounter++
        let payload = {code:invoice.code}
        await axios
        .post(apiRoutes["ACCOUNTS_RETRIEVE_VOUCHER"], payload, authHeader())
        .then((response) => 
        {
          if (response.data.code == 1) {
            this.$router.push("/finance/journal-voucher/" + invoice.code)
            window.open(url);            
          } 
          else 
          {
            alert('Failed');
          }

        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
        });
        
        this.loadingCounter--
      }
    },

    onClickNew() 
    {
      this.loadingCounter++
      this.$router.push('/finance/journal-voucher/_new');
      this.loadingCounter--
    },

    async onClickSearch() 
    {
      this.loadingCounter++;
      let payload = this.filter

      await axios
      .post(apiRoutes["CLIENT_FINANCE_JOURNAL_VOUCHERS_QUICK_SEARCH"], payload, authHeader())
      .then((response) =>
      {
        if (response.data.code == 1) {
          this.items = response.data.data
        }
        else
        {
          alert('Failed');
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });
      this.loadingCounter--
    }
    
  }
};
</script>